var _polygon, _polygon2, _line, _polygon3, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "21 27.029 36.284 9.591 5.716 9.591 21 27.029"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "21 36.418 10.783 39.149 31.217 39.149 21 36.418"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 27.029,
    x2: 21,
    y2: 36.167
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "32.443 13.974 9.557 13.974 21 27.029 32.443 13.974"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20.157,
    y1: 20.179,
    x2: 32.912,
    y2: 2.851
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorBar);
export default __webpack_public_path__ + "static/media/indoor-bar.629edd6703af6604452837230a0f9f45.svg";
export { ForwardRef as ReactComponent };